import { render, staticRenderFns } from "./HomeFocus.vue?vue&type=template&id=fa031ff0&scoped=true"
import script from "./HomeFocus.vue?vue&type=script&lang=js"
export * from "./HomeFocus.vue?vue&type=script&lang=js"
import style0 from "./HomeFocus.vue?vue&type=style&index=0&id=fa031ff0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa031ff0",
  null
  
)

export default component.exports